import React from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Services from './components/pages/Services';
import Products from './components/pages/Products';
import Sitemap from './components/Sitemap'; // Importa el componente Sitemap


function App() {
  return (
    <>
      <Router>
        
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/sitemap.xml" component={Sitemap}/>
          <Route path='/services' element={<Services />} />
          <Route path='/products' element={<Products />} />
        
        </Routes>
      </Router>
    </>
  );
}

export default App;
